export const FORWARD_ARROW_WIDTH = 8;
export const FORWARD_ARROW_HEIGHT = 12;

export const SECTION_DELIVERY_ADDRESS = 'DELIVERY ADDRESS';
export const SECTION_PAYMENT_DETAILS = 'PAYMENT DETAILS';
export const SECTION_MODE_OF_PAYMENT = 'MODE OF PAYMENT';
export const LABEL_PRODUCT_PRICE = 'Product price';
export const LABEL_DELIVERY_FEES = 'COD charges';
export const LABEL_DELIVERY_FEES_STATIC = 'Delivery fees';
export const LABEL_DISCOUNT = 'Discount';
export const LABEL_FINAL_PRICE = 'Final price';
export const LABEL_TRACK_ORDER = 'TRACK ORDER';
export const LABEL_CANCEL_RETURN = 'CANCEL / RETURN / REFUND / EXCHANGE';
export const DELIVERY_ESTIMATE_TEXT =
  'Delivery time will be shared on Whatsapp in 6 hr';
export const RETURN_POLICY_TEXT = '5 days return/ exchange available';
export const CONTINUE_SHOPPING_TEXT = 'Continue Shopping';
export const ORDER_PLACED_TITLE = 'Order Placed';

export const DELIVERY_FEE = 50;
export const ZERO_PRICE_LABEL = '₹0.00';

export const FALLBACK_TITLE = 'Unable to load order details';
export const FALLBACK_SUBTITLE =
  'Check My Orders to see the status of your order.';
export const FALLBACK_BUTTON_TEXT = 'Go to My Orders';

export const DELIVERY_PARTNER_TEXT = 'Order will be delivered via Meesho';
